const routes = [
  {
    path: "/third-party-cookies",
    name: "ThirdPartyCookiesPage",
    component: () => import(/* webpackChunkName: "ThirdPartyCookiesPage" */ "./views/ThirdPartyCookiesPage.vue")
  }
];


export default routes;
